export default {"src":"/_next/static/media/chevron_right.865356c1.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};